import api from './api'

const mrdService = {
  // MRD Files
  getFiles: (params) => api.get('/mrd/files', { params }),
  getFileById: (id) => api.get(`/mrd/files/${id}`),
  createFile: (data) => api.post('/mrd/files', data),
  updateFile: (id, data) => api.put(`/mrd/files/${id}`, data),
  updateFileStatus: (id, status, remarks) => 
    api.patch(`/mrd/files/${id}/status`, { status, remarks }),
  deleteFile: (id) => api.delete(`/mrd/files/${id}`),

  // Deficiency
  getDeficiencyChecklist: (fileId) => api.get(`/mrd/deficiency/${fileId}`),
  updateDeficiencyItem: (itemId, data) => api.put(`/mrd/deficiency/item/${itemId}`, data),
  addDeficiency: (fileId, data) => api.post(`/mrd/deficiency/${fileId}`, data),
  escalateDeficiency: (itemId, data) => api.post(`/mrd/deficiency/escalate/${itemId}`, data),
  getDeficiencyMasters: (params) => api.get('/mrd/deficiency/master', { params }),
  createDeficiencyMaster: (data) => api.post('/mrd/deficiency/master', data),

  // Documents
  getDocuments: (fileId, params) => api.get(`/mrd/documents/${fileId}`, { params }),
  uploadDocument: (fileId, formData) => {
    const config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
    return api.post(`/mrd/documents/upload/${fileId}`, formData, config)
  },
  downloadDocument: (id) => api.get(`/mrd/documents/download/${id}`, { responseType: 'blob' }),
  verifyDocument: (id) => api.patch(`/mrd/documents/verify/${id}`),

  // File Movement (Updated for new system)
  getFileMovements: (fileId, params) => api.get(`/mrd/files/${fileId}/movements`, { params }),
  getCurrentFileStatus: (fileId) => api.get(`/mrd/files/${fileId}/current-status`),

  // Legacy movement methods (for backward compatibility)
  getMovements: (params) => api.get('/mrd/movement', { params }),
  createMovement: (data) => api.post('/mrd/movement', data),
  returnMovement: (id, data) => api.post(`/mrd/movement/${id}/return`, data),

  // Medical Coding
  getCoding: (params) => api.get('/mrd/coding', { params }),
  getCodingByFile: (fileId) => api.get(`/mrd/coding/file/${fileId}`),
  createUpdateCoding: (fileId, data) => api.post(`/mrd/coding/${fileId}`, data),
  verifyCoding: (codingId, data) => api.post(`/mrd/coding/verify/${codingId}`, data),
  searchICDCodes: (params) => api.get('/mrd/coding/search/icd', { params }),
  calculateDRG: (data) => api.post('/mrd/coding/calculate-drg', data),

  // Closure
  getClosureList: (params) => api.get('/mrd/closure', { params }),
  closeFile: (fileId, data) => api.post(`/mrd/closure/${fileId}`, data),
  reopenFile: (closureId, reason) => api.post(`/mrd/closure/${closureId}/reopen`, { reason }),

  // Archive
  getArchives: (params) => api.get('/mrd/archive', { params }),
  archiveFile: (fileId, data) => api.post(`/mrd/archive/${fileId}`, data),
  retrieveArchive: (archiveId) => api.post(`/mrd/archive/${archiveId}/retrieve`),

  // Requests
  getRequests: (params) => api.get('/mrd/requests', { params }),
  createRequest: (data) => api.post('/mrd/requests', data),
  updateRequest: (id, data) => api.put(`/mrd/requests/${id}`, data),
  fulfillRequest: (id, data) => api.post(`/mrd/requests/${id}/fulfill`, data),

  // Dashboard
  getDashboardStats: () => api.get('/mrd/dashboard/stats'),
  getCodingStats: () => api.get('/mrd/coding/stats'),

  // Departments
  getDepartments: () => api.get('/api/departments/active'),
  getDepartmentStats: (deptId) => api.get(`/api/departments/${deptId}/deficiency-stats`),

  // Users
  getUsers: (params) => api.get('/api/users', { params }),
  getUserById: (id) => api.get(`/api/users/${id}`),

  // Reports
  generateReport: (type, params) => {
    return api.get(`/api/reports/${type}`, { 
      params,
      responseType: 'blob'
    })
  }
}

export default mrdService